import './styles.styl'
import React from 'react'

export default class UIComponent extends React.Component {
  componentWillMount () {
    if (this.props.customersFetched === false && this.props.customersFetching === false) {
      this.props.loadCustomers()
    }

    if (this.props.projectsFetched === false && this.props.projectsFetching === false) {
      this.props.loadProjects()
    }

    if (this.props.credentialsFetched === false && this.props.credentialsFetching === false) {
      this.props.loadCredentials()
    }
  }

  render () {
    const {
      projectsFetched,
      customersFetched,
      credentialsFetched,
      projects,
      customers,
      credentials
    } = this.props

    let content = null

    if (!projectsFetched || !customersFetched || !credentialsFetched) {
      content = (
        <div className='alert alert-primary'>
          <strong>Momentje...</strong><br />
          We halen alle gegevens op.
        </div>
      )
    }

    if (projectsFetched && customersFetched && credentialsFetched) {
      content = (
        <div className='row'>
          <div className='col-12 col-sm-4'>
            <div className='metric first'>
              <p className='value'>{customers.length}</p>
              <div className='row'>
                <div className='col-8'>
                  <p className='label'>Klanten</p>
                </div>
                <div className='col-4 text-align-right'>
                  <button className='btn btn-sm btn-success btn-rounded btn-create'>toevoegen</button>
                </div>
              </div>
            </div>
          </div>

          <div className='col-12 col-sm-4'>
            <div className='metric'>
              <p className='value'>{projects.length}</p>
              <div className='row'>
                <div className='col-8'>
                  <p className='label'>Projecten</p>
                </div>
                <div className='col-4 text-align-right'>
                  <button className='btn btn-sm btn-success btn-rounded btn-create'>toevoegen</button>
                </div>
              </div>
            </div>
          </div>

          <div className='col-12 col-sm-4'>
            <div className='metric last'>
              <p className='value'>{credentials.length}</p>
              <div className='row'>
                <div className='col-8'>
                  <p className='label'>API credentials</p>
                </div>
                <div className='col-4 text-align-right'>
                  <button className='btn btn-sm btn-success btn-rounded btn-create'>toevoegen</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }

    return (
      <div className='page'>
        <header className='header'>
          <div className='container-fluid'>
            <div className='row'>
              <div className='col-12'>
                <h1>Dashboard</h1>
              </div>
            </div>
          </div>
        </header>

        <div className='container-fluid'>
          {content}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./ui/dashboard/component.js